import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import axios from "axios";
import {
  IcUsersCog, IcUserPlus, IcEdit, IcKey, IcSave,
  IcUserEdit, IcShield, IcUsers, IcClipboard, IcReceipt, IcFileInvoice, IcTicket,
} from "../../Icons";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col
} from "reactstrap";
import Header from "../Header/Header";
import { TableHeader, Pagination, Search } from "../../DataTable"
import useFullPageLoader from "../../hooks/useFullPageLoader"
import Baja from "../../views/Baja";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ListadoUsuarios() {
  const { user } = useContext(AuthContext);
  const URL_USERS = process.env.REACT_APP_URL_USERS;
  const URL_LISTA_USERS = process.env.REACT_APP_URL_LISTA_USERS;
  const [usuarios, setUsuarios] = useState([]);

  //--- Pagination
const [comments, setComments] = useState([]);
const [loader, showLoader, hideLoader] = useFullPageLoader();
const [totalItems, setTotalItems] = useState(0);
const [currentPage, setCurrentPage] = useState(1);
const [search, setSearch] = useState("");
const [sorting, setSorting] = useState({ field: "", order: "" });
const [activo, setActivo] = useState("");
const ITEMS_PER_PAGE = 50

const URL_AREAS = process.env.REACT_APP_URL_AREAS;
const [idEdit, setIdEdit] = useState();
const [nombre, setNombre] = useState();
const [apellido, setApellido] = useState();
const [email, setEmail] = useState();
const [is_active, setIsActive] = useState();
const [areas, setAreas] = useState([]);
const [area, setArea] = useState();

const [idPermisos, setIdPermisos] = useState();

const [menu_usuarios, setMenuUsuarios] = useState();
const [usuarios_create, setUsuariosCreate] = useState();
const [usuarios_permisos, setUsuariosPermisos] = useState();

const [menu_fiscal, setMenuFiscal] = useState();
const [facturasFiscal, setFacturasFiscal] = useState();
const [compPagosFiscal, setCompPagosFiscal] = useState();
const [devolucionesFiscal, setDevolucionesFiscal] = useState();
const [notasCreditoFiscal, setNotasCreditoFiscal] = useState();
const [menu_empresas, setMenuEmpresas] = useState();

const [menu_logs, setMenuLogs] = useState();
const [menu_gastos, setMenuGastos] = useState();
const [menu_lugaresFiestas, setMenuLugaresFiestas] = useState();

// const [emailSis, setEmailSis] = useState("admin@lynqro.com");

const [modal, setModal] = useState(false);
const toggle = () => setModal(!modal);
const [text, setText] = useState(false);

const [modalPermisos, setModalPermisos] = useState(false);
const togglePermisos = () => setModalPermisos(!modalPermisos);

// ── Create modal ──────────────────────────────────────────────────────────
const [modalCreate,  setModalCreate]  = useState(false);
const toggleCreate                    = () => setModalCreate(!modalCreate);
const [newNombre,    setNewNombre]    = useState("");
const [newApellido,  setNewApellido]  = useState("");
const [newEmail,     setNewEmail]     = useState("");
const [newPassword,  setNewPassword]  = useState("");

  useEffect(() => {
    axios
      .get(URL_LISTA_USERS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allUsuarios = response.data;
        let arrayTabla = allUsuarios
        .sort((a, b) => (a.apellido > b.apellido ? 1 : -1))
        .map((a) => {
          return {
            _id:a._id,
            nombre: a.nombre,
            apellido: a.apellido,
            email: a.email,
            is_active: a.is_active,
            menu_usuarios: a.menu_usuarios,
            usuarios_create: a.usuarios_create,
            usuarios_permisos: a.usuarios_permisos,
            menu_logs: a.menu_logs,
            menu_gastos: a.menu_gastos,
            menu_fiscal: a.menu_fiscal,
            facturasFiscal: a.facturasFiscal,
            compPagosFiscal: a.compPagosFiscal,
            devolucionesFiscal: a.devolucionesFiscal,
            notasCreditoFiscal: a.notasCreditoFiscal,
            menu_empresas: a.menu_empresas,
            menu_lugaresFiestas: a.menu_lugaresFiestas,
          }
        }).filter(function (el) {
          return el != null;
        });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal)
        setUsuarios(allUsuarios);
      })
      .catch((err) => {
      });
     
      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
      });
  },[]);

  const headers = [
    { name: "Activo", field: "is_active", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Apellido", field: "apellido", sortable: true },
    { name: "Email", field: "email", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
];

  const commentsData = useMemo(() => {
    let computedComments = comments

    if (search) {
        computedComments = computedComments.filter(
            comment =>
                comment.is_active.toLowerCase().includes(search.toLowerCase()) ||
                comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
                comment.apellido.toLowerCase().includes(search.toLowerCase()) ||
                comment.email.toLowerCase().includes(search.toLowerCase())
        );
    }


    if(activo){
      computedComments = computedComments.filter((e)=>
      e.is_active.includes(activo)
      ) 
    } 

    // if(emailSis){
    //   computedComments = computedComments.filter((e)=>
    //   !e.email.includes(emailSis)
    //   ) 
    // }     

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
        const reversed = sorting.order === "asc" ? 1 : -1;
        computedComments = computedComments.sort(
            (a, b) =>
                reversed * a[sorting.field].localeCompare(b[sorting.field])
        );
    }

    //Current Page slice
    return computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
}, [comments, currentPage, search, sorting, activo]);

function Edit(idEdit, nombre, apellido, email){
  axios
  .get(`${URL_USERS}/${idEdit}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  }).then((response)=>{
    let usuarioEdit = response.data;
    setArea(usuarioEdit.areas[0]._id)
  })
  setIdEdit(idEdit)
  setNombre(nombre)
  setApellido(apellido)
  setEmail(email)
  toggle()
}

function editUsuario(event) {
  event.preventDefault();
  axios
    .patch(
      `${URL_USERS}/${idEdit}`,
      {
        nombre,
        apellido,
        email,
        areas: area,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      toggle();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
     .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
    });
}

function Permisos (
  id, 
  nombre,
  apellido,
  menu_usuarios,
  usuarios_create,
  usuarios_permisos,
  menu_logs,
  menu_gastos,
  menu_fiscal,
  facturasFiscal,
  compPagosFiscal,
  devolucionesFiscal,
  notasCreditoFiscal,
  menu_empresas,
  menu_lugaresFiestas,
  ){
        setIdPermisos(id)
        setNombre(nombre)
        setApellido(apellido)
        setMenuUsuarios(menu_usuarios)
        setUsuariosCreate(usuarios_create)
        setUsuariosPermisos(usuarios_permisos)
        setMenuLogs(menu_logs)
        setMenuGastos(menu_gastos)
        setMenuFiscal(menu_fiscal)
        setFacturasFiscal(facturasFiscal)
        setCompPagosFiscal(compPagosFiscal)
        setDevolucionesFiscal(devolucionesFiscal)
        setNotasCreditoFiscal(notasCreditoFiscal)
        setMenuEmpresas(menu_empresas)
        setMenuLugaresFiestas(menu_lugaresFiestas)
        togglePermisos()
}

function permisosUsuario(event) {
  event.preventDefault();
  axios
    .patch(
      `${URL_USERS}/${idPermisos}`,
      {
        menu_usuarios,
        usuarios_create,
        usuarios_permisos,
        menu_logs,
        menu_gastos,
        menu_fiscal,
        facturasFiscal,
        devolucionesFiscal,
        notasCreditoFiscal,
        compPagosFiscal,
        menu_empresas,
        menu_lugaresFiestas,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      togglePermisos();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
     .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
    });
}

  function handleFormCreate(event) {
    event.preventDefault();
    axios
      .post(
        URL_USERS,
        { nombre: newNombre, apellido: newApellido, email: newEmail, password: newPassword },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        setNewNombre(""); setNewApellido(""); setNewEmail(""); setNewPassword("");
        toggleCreate();
        Swal.fire("¡Listo!", "Usuario creado con éxito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      });
  }

  return (
    <>
      <Header />
      {user.menu_usuarios ? (
        <div className="card container col-sm-11">

          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcUsersCog style={{ marginRight: 8, color: "#8b5cf6" }} />
                Usuarios
              </h3>
              <p className="page-subtitle">Gestión de usuarios y permisos del sistema</p>
            </div>
            <div className="page-actions">
              {user.usuarios_create && (
                <Button color="success" size="sm" onClick={toggleCreate}>
                  <IcUserPlus style={{ marginRight: 6 }} />
                  Nuevo Usuario
                </Button>
              )}
            </div>
          </div>

          {/* Filtro */}
          <div className="filter-bar">
            <div>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 130 }}
                value={activo}
                onChange={(e) => setActivo(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-6 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => (
                <tr key={p._id}>
                  <td>{p.is_active}</td>
                  <td>{p.nombre}</td>
                  <td>{p.apellido}</td>
                  <td>{p.email}</td>
                  <td>
                    <div style={{ display: "flex", gap: 4 }}>
                      <Button
                        color="info"
                        size="sm"
                        title="Editar"
                        disabled={!user.usuarios_create}
                        onClick={() => Edit(p._id, p.nombre, p.apellido, p.email)}
                      >
                        <IcEdit />
                      </Button>
                      <Button
                        color="warning"
                        size="sm"
                        title="Permisos"
                        disabled={!user.usuarios_permisos || user.is_active !== "Si"}
                        onClick={() => Permisos(
                          p._id, p.nombre, p.apellido,
                          p.menu_usuarios, p.usuarios_create, p.usuarios_permisos,
                          p.menu_logs, p.menu_gastos, p.menu_fiscal,
                          p.facturasFiscal, p.compPagosFiscal, p.devolucionesFiscal,
                          p.notasCreditoFiscal, p.menu_empresas, p.menu_lugaresFiestas,
                        )}
                      >
                        <IcKey />
                      </Button>
                      {user.usuarios_create && (
                        <Baja
                          idStatus={p._id}
                          is_active={p.is_active}
                          URL_BAJA={process.env.REACT_APP_URL_USERS}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      {/* ── Modal: Nuevo Usuario ─────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcUserPlus style={{ marginRight: 8, color: "#10b981" }} />
          Nuevo Usuario
        </ModalHeader>
        <ModalBody>
          <Label>Nombre</Label>
          <Input type="text" value={newNombre} placeholder="Nombre" required
            onChange={(e) => setNewNombre(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Apellido</Label>
          <Input type="text" value={newApellido} placeholder="Apellido" required
            onChange={(e) => setNewApellido(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Email</Label>
          <Input type="email" value={newEmail} placeholder="Email" required
            onChange={(e) => setNewEmail(e.target.value)} style={{ marginBottom: 10 }} />
          <Label>Contraseña</Label>
          <Input type="password" value={newPassword} placeholder="Contraseña" required
            onChange={(e) => setNewPassword(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleFormCreate}>
            <IcSave style={{ marginRight: 6 }} />Dar de Alta
          </Button>
          <Button color="secondary" onClick={toggleCreate}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {/* ── Modal: Editar Usuario ─────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Editar Usuario — {nombre} {apellido}</h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <IcUserEdit />
              <span className="form-section-title">Datos del Usuario</span>
            </div>
            <div className="form-section-body">
              <Label>Nombre</Label>
              <Input
                type="text"
                value={nombre}
                required
                onChange={(e) => setNombre(e.target.value)}
                style={{ marginBottom: 10 }}
              />
              <Label>Apellido</Label>
              <Input
                type="text"
                value={apellido}
                required
                onChange={(e) => setApellido(e.target.value)}
                style={{ marginBottom: 10 }}
              />
              <Label>Email</Label>
              <Input
                type="text"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
                style={{ marginBottom: 10 }}
              />
              <Label>Área</Label>
              <Input
                type="select"
                value={area}
                required
                onChange={(e) => setArea(e.target.value)}
              >
                <option value="0">Selecciona</option>
                {areas
                  .sort((a, b) => a.name - b.name)
                  .map((a) => (
                    <option key={a._id} value={a._id}>{a.name}</option>
                  ))}
              </Input>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editUsuario}>
            <IcSave style={{ marginRight: 6 }} />Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Permisos */}
      <Modal size="lg" isOpen={modalPermisos} toggle={togglePermisos}>
        <ModalHeader toggle={togglePermisos}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: "#f5f3ff",
              display: "flex", alignItems: "center", justifyContent: "center" }}>
              <IcShield size={16} style={{ color: "#8b5cf6" }} />
            </div>
            <div>
              <div style={{ fontSize: "0.95rem", fontWeight: 700, color: "#0f172a" }}>Permisos</div>
              <div style={{ fontSize: "0.72rem", color: "#94a3b8", fontWeight: 400 }}>{nombre} {apellido}</div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "20px 24px" }}>
          {(() => {
            // Toggle switch helper
            const Toggle = ({ on, color, onToggle }) => (
              <div onClick={onToggle} style={{
                position: "relative", width: 40, height: 22, flexShrink: 0, cursor: "pointer",
                background: on ? color : "#cbd5e1", borderRadius: 11,
                transition: "background 0.2s",
              }}>
                <div style={{
                  position: "absolute", top: 3,
                  left: on ? 21 : 3, width: 16, height: 16,
                  background: "#fff", borderRadius: "50%",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
                  transition: "left 0.18s",
                }} />
              </div>
            );

            // Permission row helper
            const PermRow = ({ label, on, color, onToggle }) => (
              <div onClick={onToggle} style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "9px 12px", borderRadius: 8, cursor: "pointer",
                background: on ? `${color}0f` : "#fafafa",
                border: `1px solid ${on ? color + "33" : "#f1f5f9"}`,
                marginBottom: 6, transition: "all 0.15s",
              }}>
                <span style={{ fontSize: "0.78rem", fontWeight: 600, color: on ? "#0f172a" : "#94a3b8" }}>
                  {label}
                </span>
                <Toggle on={on} color={color} onToggle={() => {}} />
              </div>
            );

            const sections = [
              {
                title: "Usuarios", Icon: IcUsers, color: "#3b82f6",
                items: [
                  { label: "Menú Usuarios", on: menu_usuarios, set: setMenuUsuarios },
                ],
              },
              {
                title: "Logs", Icon: IcClipboard, color: "#64748b",
                items: [
                  { label: "Menú Logs", on: menu_logs, set: setMenuLogs },
                ],
              },
              {
                title: "Gastos", Icon: IcReceipt, color: "#f59e0b",
                items: [
                  { label: "Menú Gastos", on: menu_gastos, set: setMenuGastos },
                ],
              },
              {
                title: "Fiscal", Icon: IcFileInvoice, color: "#8b5cf6",
                items: [
                  { label: "Menú Fiscal",     on: menu_fiscal,          set: setMenuFiscal },
                  { label: "Facturas",         on: facturasFiscal,       set: setFacturasFiscal },
                  { label: "Devoluciones",     on: devolucionesFiscal,   set: setDevolucionesFiscal },
                  { label: "Notas de Crédito", on: notasCreditoFiscal,   set: setNotasCreditoFiscal },
                  { label: "Comp. de Pagos",   on: compPagosFiscal,      set: setCompPagosFiscal },
                  { label: "Empresas",         on: menu_empresas,        set: setMenuEmpresas },
                ],
              },
              {
                title: "Eventos", Icon: IcTicket, color: "#8b5cf6",
                items: [
                  { label: "Lugares Fiestas", on: menu_lugaresFiestas, set: setMenuLugaresFiestas },
                ],
              },
            ];

            return (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 }}>
                {sections.map((sec) => (
                  <div key={sec.title} style={{
                    background: "#fff", borderRadius: 12,
                    border: "1px solid #e2e8f0",
                    overflow: "hidden",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                  }}>
                    {/* Header */}
                    <div style={{
                      background: `${sec.color}12`,
                      borderBottom: `2px solid ${sec.color}30`,
                      padding: "10px 14px",
                      display: "flex", alignItems: "center", gap: 8,
                    }}>
                      <div style={{
                        width: 28, height: 28, borderRadius: 7,
                        background: `${sec.color}20`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}>
                        <sec.Icon size={15} style={{ color: sec.color }} />
                      </div>
                      <span style={{ fontSize: "0.75rem", fontWeight: 800, color: "#0f172a",
                        textTransform: "uppercase", letterSpacing: "0.06em" }}>
                        {sec.title}
                      </span>
                    </div>
                    {/* Items */}
                    <div style={{ padding: "12px 12px 6px" }}>
                      {sec.items.map((item) => (
                        <PermRow key={item.label}
                          label={item.label} on={!!item.on}
                          color={sec.color}
                          onToggle={() => item.set(!item.on)}
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            );
          })()}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={permisosUsuario}>
            <IcSave style={{ marginRight: 6 }} />Guardar
          </Button>
        </ModalFooter>
      </Modal>

{loader}
    </>
  );
}

export default ListadoUsuarios;
